<template>
  <div>
    <div class="row">
      <template  v-if="value.countryId == 12">
        <div class="col-12">
          <h5>
            Only corporate customers are eligible for purchases requiring delivery to the UK, we apologize for the inconvenience.
          </h5>
          <div >
            <button @click="value.gender = 'company'" :class="[{ activeGender: value.gender == 'company' },{genderBtn: value.gender != 'company'}]" class="btn my-2 btn-primary btn-appearance btn-block">
              Company
            </button>
          </div>
        </div>
      </template>
      <template  v-else>
        <div  class="col-12">
          <div class="row pb-3">
            <div class="col-md-3 mb-3 col-6">
              <button @click="value.gender = 'company'" :class="[{ activeGender: value.gender == 'company' },{genderBtn: value.gender != 'company'}]" class="btn  btn-primary btn-appearance btn-block">
                {{ $translate("Ceres::Template.addressSalutationCompany") }}
              </button>
            </div>
            <div class="col-md-3 mb-3 col-6">
              <button @click="value.gender = 'male'"  :class="[{ activeGender: value.gender == 'male' },{genderBtn: value.gender != 'male'}]" class="btn btn-primary btn-appearance btn-block">
                {{ $translate("Ceres::Template.addressSalutationMale") }}
              </button>
            </div>
            <div class="col-md-3 col-6">
              <button @click="value.gender = 'female'" :class="[{ activeGender: value.gender == 'female' },{genderBtn: value.gender != 'female'}]" class="btn btn-primary btn-appearance btn-block">
                {{ $translate("Ceres::Template.addressSalutationFemale") }}
              </button>
            </div>
            <div class="col-md-3 col-6">
              <button @click="value.gender = 'diverse'" :class="[{ activeGender: value.gender == 'diverse' },{genderBtn: value.gender != 'diverse'}]" class="btn btn-primary btn-appearance btn-block">
                {{ $translate("Ceres::Template.addressSalutationDiverse") }}
              </button>
            </div>

          </div>
        </div>
      </template>
      <template v-if="addressType === '1'">
        <!-- UK selected-->
        <template v-if="value.countryId == 12">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6">
                <div class="input-unit" data-validate="text" data-model="name1">
                  <input type="text" name="company" :id="'txtCompany' + _uid" :value="value.name1" @input="emitInputEvent('name1', $event.target.value)" data-autofocus maxlength="30">
                  <label :for="'txtCompany' + _uid">COMPANY*</label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name1" :class="{'red font-weight-bold': value.name1.length == 30}"><span v-html="value.name1.length"></span> / 30</small>
              </div>
              <div class="col-12 col-sm-6">
                <div
                    class="input-unit"
                    data-model="vatNumber"
                    v-validate:regex="vatnumberValidateExpression"
                >
                  <input type="text" name="vatNumber" :id="'txtVatNumber' + value.countryId" :data-validate-ref="vatnumberValidateExpression" :value="value.vatNumber" @input="emitInputEvent('vatNumber', $event.target.value)" data-autofocus>
                  <label :for="'txtVatNumber' + value.countryId">
                    VAT NUMBER  *
                  </label>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div v-validate:text="true" class="input-unit" data-model="name2">
                  <input type="text" name="firstName" :id="'txtFirstName' + _uid" :value="value.name2" @input="emitInputEvent('name2', $event.target.value)" data-model="name2" data-autofocus>
                  <label :for="'txtFirstName' + _uid">First Name *</label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name2" :class="{'red font-weight-bold': value.name2.length == 30}"><span v-html="value.name2.length"></span> / 30</small>
              </div>

              <div class="col-12 col-sm-6">
                <div v-validate:text="true" class="input-unit" data-model="name3" >
                  <input type="text" name="lastName" :id="'txtLastName' + _uid" :value="value.name3" @input="emitInputEvent('name3', $event.target.value)" data-model="name3">
                  <label :for="'txtLastName' + _uid">Last Name *</label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name3" :class="{'red font-weight-bold': value.name3.length == 30}"><span v-html="value.name3.length"></span> / 30</small>
              </div>
              <div class="col-sm-12">
                <div
                    class="input-unit"
                    data-model="address4"
                    v-validate:regex="EoriValidateExpression['expression']"
                >
                  <input  type="text" name="decorateAddress" :id="'decorateAddress1' + _uid"  :data-validate-ref="EoriValidateExpression['expression']" :value="value.address4" @input="emitInputEvent('address4', $event.target.value)" data-autofocus>
                  <label :for="'decorateAddress1' + _uid">
                    EORI NUMBER *
                  </label>
                </div>
              </div>


              <div  class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="telephone"
                    v-validate:text="true">
                  <input type="text" name="telephone" :id="'txtTelephone' + _uid" :value="value.telephone" @input="emitInputEvent('telephone', $event.target.value)">
                  <label :for="'txtTelephone' + _uid">
                    Phonenumber *
                  </label>
                </div>
              </div>
              <div class="col-12 col-sm-8">
                <div class="phoneHint">Phone number is only used for delivery inquieries.</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-8">
                <div class="input-unit" data-validate="text" data-model="address1">
                  <input type="text" name="street" autocomplete="address-line1" :id="'txtStreet' + _uid" :value="value.address1" @input="emitInputEvent('address1', $event.target.value)" maxlength="30">
                  <label :for="'txtStreet' + _uid">STREET*</label>
                </div>
                <small class="text-right d-block m-t-1" v-if="value.address1" :class="{'red font-weight-bold': value.address1.length == 30}"><span v-html="value.address1.length"></span> / 30</small>
              </div>

              <div  class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="address2"
                    >
                  <input type="text" name="housenumber" autocomplete="address-line2" :id="'txtNumber' + _uid" :value="value.address2" @input="emitInputEvent('address2', $event.target.value)" maxlength="30">
                  <label :for="'txtNumber' + _uid">
                    HOUSE NO.*
                  </label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.address2" :class="{'red font-weight-bold': value.address2.length == 30}"><span v-html="value.address2.length"></span> / 30</small>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-12">
                <div
                    class="input-unit"
                    data-model="address3"
                >
                  <input type="text" name="buildingName" :id="'decorateAddress0' + _uid" :value="value.address3"  @input="emitInputEvent('address3', $event.target.value)" maxlength="30">
                  <label :for="'decorateAddress0' + _uid">
                    Address Line 3
                  </label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.address3" :class="{'red font-weight-bold': value.address3.length == 30}"><span v-html="value.address3.length"></span> / 30</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="input-unit" data-validate="text" data-model="town">
              <input type="text" name="town" :id="'txtPlace' + _uid" :value="value.town"  @input="emitInputEvent('town', $event.target.value)">
              <label :for="'txtPlace' + _uid">TOWN*</label>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="input-unit" data-validate="text" data-model="postalCode">
              <input type="text" name="zip" :id="'txtZip' + _uid" :value="value.postalCode"  @input="emitInputEvent('postalCode', $event.target.value)">
              <label :for="'txtZip' + _uid">POSTOCDE*</label>
            </div>
          </div>
          <slot name="custom-address-fields"></slot>
        </template>
        <template v-else>
          <!-- DHLPackingStationDE -->
          <template v-if="value.showPickupStation && selectedCountry.isoCode2 === 'DE'">
            <div class="col-12">
              <div class="row">
                <div
                    class="col-12 col-sm-6"
                    v-if="value.gender === 'company'">
                  <div class="input-unit" data-model="name1" data-validate="text">
                    <input type="text" name="company" :id="'txtCompany' + _uid" :value="value.name1" @input="emitInputEvent('name1', $event.target.value)">
                    <label :for="'txtCompany' + _uid">{{ $translate("Ceres::Template.addressCompany") }}*</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row">
                  <!-- First name -->
                  <div class="col-12 col-sm-4">
                    <div v-validate:text="true" class="input-unit" data-model="name2">
                      <input type="text" name="firstName" :id="'txtFirstName' + _uid" :value="value.name2" @input="emitInputEvent('name2', $event.target.value)">
                      <label :for="'txtFirstName' + _uid">{{ $translate("Ceres::Template.addressFirstName") }}*</label>
                    </div>
                    <small class="text-right d-block m--t-1" v-if="value.name2" :class="{'red font-weight-bold': value.name2.length == 30}"><span v-html="value.name2.length"></span> / 30</small>
                  </div>
                  <!-- Last name -->
                  <div class="col-12 col-sm-4">
                    <div v-validate:text="true" class="input-unit" data-model="name3">
                      <input type="text" name="lastName" :id="'txtLastName' + _uid" :value="value.name3" @input="emitInputEvent('name3', $event.target.value)">
                      <label :for="'txtLastName' + _uid">{{ $translate("Ceres::Template.addressLastName") }} * </label>
                    </div>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.name3" :class="{'red font-weight-bold': value.name3.length == 30}"><span v-html="value.name3.length"></span> / 30</small>
                <!-- Phone number -->
                  <div  class="col-12 col-sm-4">
                    <div
                        v-if="value.countryId !=1"
                        class="input-unit"
                        data-model="telephone"
                    >
                      <input type="text" name="telephone" :id="'txtTelephone' + _uid" :value="value.telephone" @input="emitInputEvent('telephone', $event.target.value)">
                      <label :for="'txtTelephone' + _uid">
                        {{ transformTranslation("Ceres::Template.addressTelephone", "de", "delivery_address.phoneNumber") }}
                      </label>
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-12" v-if="isParcelOrOfficeAvailable">
              <div class="row">
                <div class="col-12">
                  <input type="checkbox" name="togglePickup" :checked="value.showPickupStation" @change="togglePickupStation($event.target.checked)" :id="'showPickup' + _uid">
                  <label :for="'showPickup' + _uid">{{ $translate("Ceres::Template.addressToPickupStation") }}</label>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <!-- Packstation, Postfiliale -->
                <div class="col-12 col-sm-8">
                  <div class="input-unit" data-model="address1">
                    <select class="custom-select" :value="value.address1" @change="emitInputEvent('address1', $event.target.value)">
                      <option v-if="isParcelBoxAvailable || isMyAccount" value="PACKSTATION" :selected="isPickupStation">{{ $translate("Ceres::Template.addressPackingStation") }}</option>
                      <option v-if="isPostOfficeAvailable || isMyAccount" value="POSTFILIALE" :selected="isPostOffice">{{ $translate("Ceres::Template.addressPostOffice") }}</option>
                    </select>
                    <label>{{ $translate("Ceres::Template.addressPickupLocation") }}</label>
                  </div>
                </div>

                <!-- Packstationsnummer, Filialnummer -->
                <div class="col-12 col-sm-4">
                  <div class="input-unit" data-validate="text" data-model="address2">
                    <input type="text" name="housenumber" autocomplete="address-line2" :id="'txtNumber' + _uid" :value="value.address2" @input="emitInputEvent('address2', $event.target.value)">
                    <label v-if="isPickupStation" :for="'txtNumber' + _uid">{{ $translate("Ceres::Template.addressPackingStationNumber") }}*</label>
                    <label v-if="isPostOffice" :for="'txtNumber' + _uid">{{ $translate("Ceres::Template.addressPostOfficeNumber") }}*</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row">
                <!-- PostNummer -->
                <div class="col-12 col-sm-6">
                  <div class="input-unit" data-validate="text" data-model="postNumber">
                    <input type="text" name="postnumber" :id="'postnumber' + _uid"
                           :value="value.postNumber" @input="emitInputEvent('postNumber', $event.target.value)">
                    <label :for="'postnumber' + _uid">{{ $translate("Ceres::Template.addressPostNummer") }}*</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="input-unit" data-validate="text" data-model="postalCode">
                <input type="text" name="zip" :id="'txtZip' + _uid" :value="value.postalCode" @input="emitInputEvent('postalCode', $event.target.value)">
                <label :for="'txtZip' + _uid">{{ $translate("Ceres::Template.addressZip") }}*</label>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="input-unit" data-validate="text" data-model="town">
                <input type="text" name="town" :id="'txtPlace' + _uid" :value="value.town" @input="emitInputEvent('town', $event.target.value)">
                <label :for="'txtPlace' + _uid">{{ $translate("Ceres::Template.addressPlace") }}*</label>
              </div>
            </div>

            <slot name="custom-address-fields"></slot>
          </template>
          <!-- normal billing adress -->
          <template v-else>
            <div class="col-12">
              <div class="row">
                <div
                    class="col-12 col-sm-6"
                    v-if="value.gender === 'company'">
                  <div class="input-unit" data-validate="text" data-model="name1">
                    <input type="text" name="company" :id="'txtCompany' + _uid" :value="value.name1" @input="emitInputEvent('name1', $event.target.value)" data-autofocus maxlength="30">
                    <label :for="'txtCompany' + _uid">{{ $translate("Ceres::Template.addressCompany") }}*</label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.name1" :class="{'red font-weight-bold': value.name1.length == 30}"><span v-html="value.name1.length"></span> / 30</small>
                </div>

                <div class="col-12 col-sm-6" v-if="value.gender === 'company'">
                  <template v-if="[3,44,7,9,11,12,10,13,16,15,54,18,33,17,19,21,2,23,22,41,24,26,27,8,6,14,5].includes(selectedCountry.id)">
                    <div
                        class="input-unit"
                        data-model="vatNumber"
                        v-validate:regex="vatnumberValidateExpression"
                    >
                      <input  type="text" name="vatNumber" :id="'txtVatNumber' + value.countryId" :data-validate-ref="vatnumberValidateExpression" :value="value.vatNumber" @input="emitInputEvent('vatNumber', $event.target.value)" data-autofocus>
                      <label :for="'txtVatNumber' + value.countryId">
                        {{ transformTranslation("Ceres::Template.addressVatNumber", "de", "billing_address.vatNumber") }}  *
                      </label>
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      <div
                          class="input-unit"
                          data-model="vatNumber">
                        <input type="text" name="vatNumber" :id="'txtVatNumber' + value.countryId"  :value="value.vatNumber" @input="emitInputEvent('vatNumber', $event.target.value)" data-autofocus>
                        <label :for="'txtVatNumber' + value.countryId">
                          {{ transformTranslation("Ceres::Template.addressVatNumber", "de", "billing_address.vatNumber") }}
                        </label>
                      </div>
                    </div>
                  </template>
                </div>

              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div v-validate:text="true" class="input-unit" data-model="name2" >
                    <input  type="text" name="firstName" :id="'txtFirstName' + _uid" :value="value.name2"  @input="emitInputEvent('name2', $event.target.value)" data-autofocus maxlength="30">
                    <label :for="'txtFirstName' + _uid">{{ $translate("Ceres::Template.addressFirstName") }}*</label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.name2" :class="{'red font-weight-bold': value.name2.length == 30}"><span v-html="value.name2.length"></span> / 30</small>
                </div>
                <div class="col-12 col-sm-6">
                  <div v-validate:text="true" class="input-unit" data-model="name3" >
                    <input type="text" name="lastName" :id="'txtLastName' + _uid" :value="value.name3" @input="emitInputEvent('name3', $event.target.value)" maxlength="30">
                    <label :for="'txtLastName' + _uid">{{ $translate("Ceres::Template.addressLastName") }} * </label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.name3" :class="{'red font-weight-bold': value.name3.length == 30}"><span v-html="value.name3.length"></span> / 30</small>
                </div>
                <div  class="col-12 col-sm-4">
                  <div class="input-unit" data-model="birthday" v-validate:date="!!value.birthday && !!value.birthday.length">
                    <input type="date" min="1901-12-14" :max="new Date().toISOString().split('T')[0]" name="birthday" :placeholder="$translate('Ceres::Template.addressBirthdatePlaceholder')" :id="'txtBirthdate' + _uid" :value="value.birthday" @input="emitInputEvent('birthday', $event.target.value)">
                    <label :for="'txtBirthdate' + _uid">
                      {{ transformTranslation("Ceres::Template.addressBirthdate", "de", "billing_address.birthday") }}
                    </label>
                  </div>
                </div>
                <div v-if="value.countryId !=1" class="col-12 col-sm-4">
                  <div
                      class="input-unit"
                      data-model="telephone"
                      v-validate:text="value.countryId!=1">
                    <input type="text" name="telephone" :id="'txtTelephone' + _uid" :value="value.telephone" @input="emitInputEvent('telephone', $event.target.value)">
                    <label :for="'txtTelephone' + _uid">
                      {{ transformTranslation("Ceres::Template.addressTelephone", "de", "billing_address.phoneNumber") }} *
                    </label>
                  </div>
                </div>
                <div v-if="value.countryId != 1" class="col-12 col-sm-8">
                  <div class="phoneHint">{{ $translate("Woerner::Template.phoneSentence") }}</div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-12 col-sm-8">
                  <div class="input-unit" data-validate="text" data-model="address1">
                    <input type="text" name="street" autocomplete="address-line1" :id="'txtStreet' + _uid" :value="value.address1" @input="emitInputEvent('address1', $event.target.value)" maxlength="30">
                    <label :for="'txtStreet' + _uid">{{ $translate("Ceres::Template.addressStreet") }}*</label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.address1" :class="{'red font-weight-bold': value.address1.length == 30}"><span v-html="value.address1.length"></span> / 30</small>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="input-unit" data-validate="text" data-model="address2">
                    <input type="text" name="housenumber" autocomplete="address-line2" :id="'txtNumber' + _uid" :value="value.address2" @input="emitInputEvent('address2', $event.target.value)" maxlength="5">
                    <label :for="'txtNumber' + _uid">{{ $translate("Ceres::Template.addressNumber") }}*</label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.address2" :class="{'red font-weight-bold': value.address2.length == 5}"><span v-html="value.address2.length"></span> / 5</small>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="row">
                <div  class="col-12 col-sm-6">
                  <div
                      class="input-unit"
                      data-model="address3"
                     >
                    <input type="text" name="decorateAddress" :id="'decorateAddress0' + _uid" :value="value.address3" @input="emitInputEvent('address3', $event.target.value)" maxlength="30">
                    <label :for="'decorateAddress0' + _uid">
                      {{ transformTranslation("Ceres::Template.addressAdditionalAddress1", "de", "billing_address.address3") }}
                    </label>
                  </div>
                  <small class="text-right d-block m--t-1" v-if="value.address3" :class="{'red font-weight-bold': value.address3.length == 30}"><span v-html="value.address3.length"></span> / 30</small>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="input-unit" data-validate="text" data-model="postalCode">
                <input type="text" name="zip" :id="'txtZip' + _uid" :value="value.postalCode" @input="emitInputEvent('postalCode', $event.target.value)">
                <label :for="'txtZip' + _uid">{{ $translate("Ceres::Template.addressZip") }}*</label>
              </div>
            </div>
            <div class="col-12 col-sm-4">
              <div class="input-unit" data-validate="text" data-model="town">
                <input type="text" name="town" :id="'txtPlace' + _uid" :value="value.town" @input="emitInputEvent('town', $event.target.value)">
                <label :for="'txtPlace' + _uid">{{ $translate("Ceres::Template.addressPlace") }}*</label>
              </div>
            </div>

            <slot name="custom-address-fields"></slot>
          </template>
        </template>
      </template>
      <!-- DeliveryAddress -->
      <template v-else>
        <template >
          <div class="col-12" >
            <div class="row">
              <div class="col-12 col-sm-6" v-if="value.gender === 'company'">
                <div class="input-unit" data-validate="text" data-model="name1">
                  <input type="text" name="company" :id="'txtCompany' + _uid" :value="value.name1" @input="emitInputEvent('name1', $event.target.value)" data-autofocus maxlength="30">
                  <label :for="'txtCompany' + _uid">{{ $translate("Ceres::Template.addressCompany") }}*</label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name1" :class="{'red font-weight-bold': value.name1.length == 30}"><span v-html="value.name1.length"></span> / 30</small>
              </div>
              <div class="col-12 col-sm-6" v-if="value.gender === 'company'">
                <template v-if="[3,44,7,9,11,12,10,13,16,15,54,18,33,17,19,21,2,23,22,41,24,26,27,8,6,14,5].includes(selectedCountry.id)">
                  <div
                      class="input-unit"
                      data-model="vatNumber"
                      v-validate:regex="vatnumberValidateExpression">
                    <input type="text" name="vatNumber" :id="'txtVatNumber' + value.countryId" :data-validate-ref="vatnumberValidateExpression" :value="value.vatNumber" @input="emitInputEvent('vatNumber', $event.target.value)" data-autofocus>
                    <label :for="'txtVatNumber' + value.countryId">
                      {{ transformTranslation("Ceres::Template.addressVatNumber", "de", "delivery_address.vatNumber") }}  *
                    </label>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <div class="input-unit"
                         data-model="vatNumber">
                      <input type="text" name="vatNumber" :id="'txtVatNumber' + value.countryId"  :value="value.vatNumber" @input="emitInputEvent('vatNumber', $event.target.value)" data-autofocus>
                      <label :for="'txtVatNumber' + value.countryId">
                        {{ transformTranslation("Ceres::Template.addressVatNumber", "de", "delivery_address.vatNumber") }}
                      </label>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6">
                <div v-validate:text="true" class="input-unit" data-model="name2" >
                  <input type="text" name="firstName" :id="'txtFirstName' + _uid" :value="value.name2" @input="emitInputEvent('name2', $event.target.value)" data-autofocus maxlength="30">
                  <label :for="'txtFirstName' + _uid">{{ $translate("Ceres::Template.addressFirstName") }}
                  </label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name2" :class="{'red font-weight-bold': value.name2.length == 30}"><span v-html="value.name2.length"></span> / 30</small>
              </div>
              <div class="col-12 col-sm-6">
                <div v-validate:text="true" class="input-unit" data-model="name3" >
                  <input type="text" name="lastName" :id="'txtLastName' + _uid" :value="value.name3" @input="emitInputEvent('name3', $event.target.value)" maxlength="30">
                  <label :for="'txtLastName' + _uid">{{ $translate("Ceres::Template.addressLastName") }}* </label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.name3" :class="{'red font-weight-bold': value.name3.length == 30}"><span v-html="value.name3.length"></span> / 30</small>
              </div>
              <div v-if="value.countryId!=1" class="col-12 col-sm-4">
                <div
                    class="input-unit"
                    data-model="telephone"
                    v-validate:text="value.countryId!=1">
                  <input type="text" name="telephone" :id="'txtTelephone' + _uid" :value="value.telephone" @input="emitInputEvent('telephone', $event.target.value)">
                  <label :for="'txtTelephone' + _uid">
                    {{ transformTranslation("Ceres::Template.addressTelephone", "de", "delivery_address.phoneNumber") }} *
                  </label>
                </div>
              </div>
              <div  v-if="value.countryId!=1" class="col-12 col-sm-8">
                <div class="phoneHint">{{ $translate("Woerner::Template.phoneSentence") }}</div>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="isParcelOrOfficeAvailable">
            <div class="row">
              <div class="col-12">
                <input type="checkbox" name="togglePickup" :checked="value.showPickupStation" @change="togglePickupStation($event.target.checked)" :id="'showPickup' + _uid">
                <label :for="'showPickup' + _uid">{{ $translate("Ceres::Template.addressToPickupStation") }}</label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-8">
                <div class="input-unit" data-validate="text" data-model="address1">
                  <input type="text" name="street" autocomplete="address-line1" :id="'txtStreet' + _uid" :value="value.address1" @input="emitInputEvent('address1', $event.target.value)" maxlength="30">
                  <label :for="'txtStreet' + _uid">{{ $translate("Ceres::Template.addressStreet") }}*</label>
                </div>
              </div>

              <div class="col-12 col-sm-4">
                <div class="input-unit" data-validate="text" data-model="address2">
                  <input type="text" name="housenumber" autocomplete="address-line2" :id="'txtNumber' + _uid" :value="value.address2" @input="emitInputEvent('address2', $event.target.value)">
                  <label :for="'txtNumber' + _uid">{{ $translate("Ceres::Template.addressNumber") }}*</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div  class="col-12 col-sm-6">
                <div
                    class="input-unit"
                    data-model="address3"
                    >
                  <input type="text" name="decorateAddress" :id="'decorateAddress0' + _uid"
                         :value="value.address3" @input="emitInputEvent('address3', $event.target.value)" maxlength="30">
                  <label :for="'decorateAddress0' + _uid">
                    {{ transformTranslation("Ceres::Template.addressAdditionalAddress1", "de", "delivery_address.address3") }}
                  </label>
                </div>
                <small class="text-right d-block m--t-1" v-if="value.address3" :class="{'red font-weight-bold': value.address3.length == 30}"><span v-html="value.address3.length"></span> / 30</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="input-unit" data-validate="text" data-model="postalCode">
              <input type="text" name="zip" :id="'txtZip' + _uid" :value="value.postalCode" @input="emitInputEvent('postalCode', $event.target.value)">
              <label :for="'txtZip' + _uid">{{ $translate("Ceres::Template.addressZip") }}*</label>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="input-unit" data-validate="text" data-model="town">
              <input type="text" name="town" :id="'txtPlace' + _uid" :value="value.town" @input="emitInputEvent('town', $event.target.value)">
              <label :for="'txtPlace' + _uid">{{ $translate("Ceres::Template.addressPlace") }}*</label>
            </div>
          </div>
          <slot name="custom-address-fields"></slot>
        </template>
      </template>
      <div class="col-12 col-sm-4">
        <country-select
            :selected-country-id="value.countryId"
            :selected-state-id="value.stateId"
            @country-changed="onSelectedCountryChanged($event)"
            @state-changed="emitInputEvent('stateId', $event)"
            :address-type="addressType"
            >
        </country-select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CountrySelect from "./CountrySelect.vue";

export default {

  name: "address-input-group",
  components:
      {
        CountrySelect
      },
  props:
      {
        defaultCountry: {
          type: String,
          default: "DE"
        },
        addressType: String,
        modalType: String,
        template: String,
        value: {
          type: Object,
          default()
          {
            return {};
          }
        },
      },
  computed:
      {
        currentLang()
        {
          if(App)
          {
            return App.language;
          }
          else {
            return 'de';
          }
        },
        isMyAccount()
        {
          return App.templateType === "my-account";
        },
        isPickupStation()
        {
          return this.value && this.value.address1 === "PACKSTATION" && this.isParcelBoxAvailable;
        },
        isPostOffice()
        {
          return this.value && this.value.address1 === "POSTFILIALE" && this.isPostOfficeAvailable;
        },
        isParcelOrOfficeAvailable()
        {
          return (this.isParcelBoxAvailable || this.isPostOfficeAvailable) && this.selectedCountry && this.selectedCountry.isoCode2 === "DE" && this.addressType === "2";
        },
        ...mapState({
          isParcelBoxAvailable: state => state.checkout.shipping.isParcelBoxAvailable,
          isPostOfficeAvailable: state => state.checkout.shipping.isPostOfficeAvailable
        })
      },
  data()
  {
    return {
      EoriValidateExpression:{'expression':/(GB)[0-9]{12}$/g},
      vatnumberValidateExpression:'',
      stateList  : [],
      countryLocaleList: ["DE", "GB"],
      localeToShow: this.defaultCountry,
      selectedCountry: {}
    };
  },
  methods:
      {
        vatnumberValidate(countryId)
        {
          let country =
              {
                12: /(GB)[0-9]{9}$/g,
                3:/(BE)0[0-9]{9}$/g,
                44:/(BG)[0-9]{9,10}$/g,
                7:/(DK)[0-9]{8}$/g,
                9:/(EE)[0-9]{9}$/g,
                11:/(FI)[0-9]{8}$/g,
                10:/(FR)[0-9A-Z]{2}[0-9]{9}$/g,
                13:/(EL|GR)[0-9]{9}$/g,
                16:/(IE)[0-9]{7}[A-W]{1}[A-I]{1}?|(IE)[0-9]{1}[A-Z0-9]{1}[0-9]{5}[A-Z]{1}$/g,
                15:/(IT)[0-9]{11}$/g,
                54:/(HR)[0-9]{11}$/g,
                18:/(LV)[0-9]{11}$/g,
                33:/(LT)([0-9]{9}|[0-9]{12})$/g,
                17:/(LU)[0-9]{8}$/g,
                19:/(MT)[0-9]{8}$/g,
                21:/(NL)[0-9,A-Z,*,+]{12}$/g,
                2:/(AT)U[0-9]{8}$/g,
                23:/(PL)[0-9]{10}$/g,
                22:/(PT)[0-9]{9}$/g,
                41:/(RO)[0-9]{2,10}$/g,
                24:/(SE)[0-9]{12}$/g,
                26:/(SK)[0-9]{10}$/g,
                27:/(SI)[0-9]{8}$/g,
                8:/(ES)[0-9A-Z][0-9]{7}[0-9A-Z]$/g,
                6:/(CZ)[0-9]{8,9,10}$/g,
                14:/(HU)[0-9]{8}$/g,
                5:/(CY)[0-9]{8}[A-Z]{1}$/g,
              }

          this.vatnumberValidateExpression = country[countryId];

        },
        /**
         * Update the address input group to show.
         * @param shippingCountry
         */
        onSelectedCountryChanged(shippingCountry)
        {
          this.selectedCountry = shippingCountry;
          if (shippingCountry && this.countryLocaleList.indexOf(shippingCountry.isoCode2) >= 0)
          {
            this.localeToShow = shippingCountry.isoCode2;
          }
          else
          {
            this.localeToShow = this.defaultCountry;
          }

          this.emitInputEvent("countryId", shippingCountry.id);

          if (this.isPickupStation || this.isPostOffice)
          {
            this.togglePickupStation(false);
          }
          this.vatnumberValidate(shippingCountry.id);

          if(shippingCountry.id == 12)
          {
            this.emitInputEvent("gender", 'company');
            if(typeof ceresStore !== 'undefined' && ceresStore !== undefined && ceresStore !== null  && ceresStore.state.address.deliveryAddres !== null &&  ceresStore.state.address.deliveryAddress.id != -99)
            {
              this.$store.dispatch('selectAddress',{ selectedAddress:{id:-99} , addressType: "2"});
            }
          }


        },

        togglePickupStation(showPickupStation)
        {
          const emitInputs =
              {
                address1: "",
                address2: "",
                address3: "",
                showPickupStation: showPickupStation
              };

          if (showPickupStation)
          {
            emitInputs.address1 = this.isParcelBoxAvailable ? "PACKSTATION" : "POSTFILIALE";
          }

          for (const input in emitInputs)
          {
            this.emitInputEvent(input, emitInputs[input]);
          }
        },

        /**
         * @param {string} field
         * @param {number} value
         */
        emitInputEvent(field, value)
        {
          this.$emit("input", { field, value });
        },
        transformTranslation(translationKey )
        {
          return this.$translate(translationKey);
        },
      }
}
</script>
